import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { TextAreaBox, CheckBox, DatePicker } from 'fw/forms';
import { Tooltip, ActionButton, Button } from 'fw/components';
import { CommentsGrid, ReviewUpload, AdminAppIdHeader } from 'areas/shared/components';
import { SetupTab } from 'areas/shared/pages/setup';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import * as APIAdmin from 'modules/app/API'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel';
import * as ReportManager from 'modules/reports/ReportManager';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import UploadsConfig from './UploadsConfig';
import { QueueType, TooltipCode } from 'areas/shared/consts';
import * as Modals from 'fw/globals/Modals';
import FastTrackLabel from 'areas/admin/shared/FastTrackLabel';

class BusinessCertification extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            reviewComment: '',
            tooltips: []
        }
    }

    skipValidations() {
        return App.hasPrivilege("AdminSkipValidations");
    }

    updatePostData = (form, dirty) => {
        for (var ref in this.refs) {
            this._form.register(this.refs[ref]);
        }
        if (this.state.form.showComplete)
            this.validateReviewStatus(form);
        this.setState({ form });

        if (dirty === true)
            this.dirt();
    }

    validateReviewStatus = (form) => {
        let canComplete =
            (
                this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
            ) ||
            (
                this.state.form.reviewUploads.every((reviewUpload) => {
                    return (reviewUpload.upload.uploadKey === "NGLCC" && (!this.state.form.nglcc || reviewUpload.validDocument)) ||
                        (reviewUpload.upload.uploadKey === "NMSDC" && (!this.state.form.nmsdc || reviewUpload.validDocument)) ||
                        (reviewUpload.upload.uploadKey === "WBENC" && (!this.state.form.wbenc || reviewUpload.validDocument));
                })
                && (this.state.form.otherFiles == null
                    || this.state.form.otherFiles.every((document) => { return document.uploadModel && document.uploadModel.validDocument; }))
            );

        if (form.reviewStatus !== null && form.reviewStatus !== undefined && form.reviewStatus && !canComplete)
            form.reviewStatus = false;
    }

    beforeSave = (cb) => {
        this.handleSave(cb);
    }

    evaluateBlank = (uploadKey) => {
        let form = this.state.form;
        let isNmsdc = uploadKey.toUpperCase() === "NMSDC";
        let isWbenc = uploadKey.toUpperCase() === "WBENC";
        let isNglcc = uploadKey.toUpperCase() === "NGLCC";

        if ((isNmsdc && !form.nmsdc) || (isWbenc && !form.wbenc) || (isNglcc && !form.nglcc)) {
            if (isNmsdc)
                form.nmsdcExpirationDate = null;
            if (isWbenc)
                form.wbencExpirationDate = null;
            if (isNglcc)
                form.nglccExpirationDate = null;

            var foundIndex = this.state.form.reviewUploads.findIndex(x => x.upload.uploadKey === uploadKey.toUpperCase());
            if (foundIndex !== -1) {
                this.state.form.reviewUploads[foundIndex].upload.storageToken = null;
                this.state.form.reviewUploads[foundIndex].upload.fileName = null;
                this.state.form.reviewUploads[foundIndex].validDocument = false;
            }
        }
        this.updatePostData(form, true);
    }

    evaluateNoneOfAbove = () => {
        let form = this.state.form;

        if (form.none) {
            this.state.form.reviewUploads.forEach(reviewUpload => {
                reviewUpload.upload.storageToken = null;
                reviewUpload.upload.fileName = null;
                reviewUpload.validDocument = false;
            }
            );
            form.nmsdc = false;
            form.nmsdcExpirationDate = null;
            form.wbenc = false;
            form.wbencExpirationDate = null;
            form.nglcc = false;
            form.nglccExpirationDate = null;
            form.cve = false;
            form.sbA8 = false;
            form.sba = false;
            form.dvbe = false;
            form.naVOBA = false;
            form.di = false;
        }
        this.updatePostData(form, true);
    }

    privileges() {
        return {
            edit: App.hasPrivilege("AdminAppManagementEdit")
        }
    }

    urls() {
        return {
            get: API.Admin.url('/certification/getBusinessCertification'),
            save: API.Admin.url('/certification/saveBusinessCertification'),
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
            queueTypeCode: this.props.queueTypeCode
        }
    }

    saveRequest() {
        return {
            certificationId: this.state.form.certificationId,
            entityId: this.state.form.savedEntityId,
            nmsdc: this.state.form.nmsdc,
            nmsdcExpirationDate: this.state.form.nmsdcExpirationDate,
            wbenc: this.state.form.wbenc,
            wbencExpirationDate: this.state.form.wbencExpirationDate,
            nglcc: this.state.form.nglcc,
            nglccExpirationDate: this.state.form.nglccExpirationDate,
            cve: this.state.form.cve,
            sba8: this.state.form.sbA8,
            sba: this.state.form.sba,
            dvbe: this.state.form.dvbe,
            naVOBA: this.state.form.naVOBA,
            di: this.state.form.di,
            none: this.state.form.none,
            otherFiles: this.state.form.otherFiles,
            rowVersion: this.state.form.rowVersion,
            reviewStatus: this.state.form.reviewStatus,
            reviewUploads: this.state.form.reviewUploads,
            reviewQueueTypeCode: this.state.form.certificationQueueTypeCode,
            reviewComment: this.state.reviewComment
        }
    }

    handleNmsdcUploadRemove = () => {
        let form = this.state.form;
        form.nmsdcExpirationDate = "";
    }

    handleWbencUploadRemove = () => {
        let form = this.state.form;
        form.wbencExpirationDate = "";
    }

    handleNglccUploadRemove = () => {
        let form = this.state.form;
        form.nglccExpirationDate = "";
    }

    handleDescriptionChange = (value, index) => {
        let form = this.state.form;
        form.otherFiles[index].description = value;

        this.updatePostData(form, true)
    };

    handleOtherDocumentRemove = (index) => {
        let form = this.state.form;

        form.otherFiles[index].description = "";
    };

    handleUploadOtherFileChange = (formUpload, index) => {
        let form = this.state.form;
        form.otherFiles[index].uploadModel = formUpload;

        this.updatePostData(form, true)
    }

    handleAddAnotherCertification = () => {
        let form = this.state.form;
        form.otherFiles.push({
            businessCertificationOtherFileId: -Math.abs(Date.now() | 0)
        });

        this.updatePostData(form);
    }

    handleRemoveOtherDocument = (i) => {
        let form = this.state.form;
        form.otherFiles.splice(i, 1);

        this.updatePostData(form, true);
    }

    renderOtherFiles = () => {
        return this.state.form.otherFiles.map((item, index) => (
            <Row key={item.businessCertificationOtherFileId}>
                <Col md={12}>
                    <ReviewUpload
                        reviewUpload={item.uploadModel}
                        onChange={formUpload => this.handleUploadOtherFileChange(formUpload, index)}
                        notApplicableAvailable={false}
                        queueTypeCode={this.state.form.certificationQueueTypeCode} />
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <TextAreaBox
                            required
                            maxLength={500}
                            placeholder="Briefly describe your Uploaded Certification here..."
                            value={item.description}
                            onChange={value => this.handleDescriptionChange(value, index)}
                            ref={`otherFileDescription_${index}`}
                        />
                    </FormGroup>
                </Col>
                <Col md={1} style={{ marginTop: 15, marginLeft: -15, paddingLeft: 0, textAlign: "left" }}>
					<Button type="button" bsStyle="link" onClick={() => this.handleRemoveOtherDocument(index)} title="Remove Certification">
                        <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
					</Button>
                </Col>
            </Row>
        ));
    };

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    isValidated(data) {
        return data.isSubmitted;
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: 'BusinessCertificationInfoReport',
            format: 'PDF',
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        });

        ReportManager.execute(rq);
    }

    handleReviewUpload = (formUpload) => {
        let form = this.state.form;
        var items = form.reviewUploads;

        var foundIndex = items.findIndex(x => x.upload.uploadKey === formUpload.upload.uploadKey);
        if (foundIndex === -1) {
            items.push(formUpload);
        }
        else {
            items[foundIndex] = formUpload;
        }

        form["reviewUploads"] = items;

        this.updatePostData(form, true);
    }

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form["reviewStatus"] = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleSave = (cb) => {
        const me = this;
        const rq = me.saveRequest();

        APIAdmin.Admin.post('/certification/checkFastTrackEligibilityChange', rq,
        {
            success: (sr) => {
                if (sr.data.fastTrackChanged) {
                    let trackMode = sr.data.fastTrack ? "Fast Track" : "Normal Track";
                    Modals.confirm(
                        "You are about to change the track to <b>" + trackMode + "</b> for this application. <br /><br />" +
                        "If you wish to continue with this action, please select 'Yes'. <br /><br />" +
                        "If you wish to cancel, please select 'No', and you will be returned to the previous screen.",
                        function () {
                            me._ast.checkReviewStatus(cb);
                        }
                    );
                }
                else
                    me._ast.checkReviewStatus(cb);
            }
        });
        return false;
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
        this.props.setupProps._certificationSetup.getCertificationSetup();
        let form = {
            ...this.state.form,
            fastTrack: data.fastTrack
        };
        this.updatePostData(form, false);
    }

    afterSaveTabSelect = (entityId, data) => {
        this.props.setupProps._certificationSetup.getCertificationSetup();
    }

    addCommentFromSave = (comment) => {
        if (comment === null)
            return;

        let comments = this.state.form.comments;

        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    handleExpDateTooltip = (uploadKey) => {
        switch (uploadKey.toUpperCase()) {
            case "NMSDC": return TooltipCode.CERTIFICATION.NMSDCEXPDATE
            case "WBENC": return TooltipCode.CERTIFICATION.WBENCEXPDATE
            case "NGLCC": return TooltipCode.CERTIFICATION.NGLCCEXPDATE
            default: return ''
        }
    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'CER'}
                queueTypeCode={this.state.form.certificationQueueTypeCode}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={6}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderUploadFields = () => {
        var me = this;
        return this.state.form.reviewUploads.map((item, index) => (
            me.renderUploadField(item)
        ));
    }

    renderUploadField = (reviewUpload) => {
        const uploadKey = reviewUpload.upload.uploadKey;
        let label = null; let formName = null; let formProperty = null; let expirationDateFormName = null;
        if (uploadKey.toUpperCase() === "NMSDC") {
            label = 'NMSDC - <a href="https://www.nmsdc.org/" target="_blank">National Minority Supplier Development Council</a>';
            formName = 'nmsdc';
            formProperty = this.state.form.nmsdc;
            expirationDateFormName = 'nmsdcExpirationDate';
        }
        else if (uploadKey.toUpperCase() === "NGLCC") {
            label = 'NGLCC - <a href="https://www.nglcc.org/" target="_blank">National Gay &amp; Lesbian Chamber of Commerce</a>';
            formName = 'nglcc';
            formProperty = this.state.form.nglcc;
            expirationDateFormName = 'nglccExpirationDate';
        }
        else if (uploadKey.toUpperCase() === "WBENC") {
            label = 'WBENC - <a href="https://www.wbenc.org/" target="_blank">Women’s Business Enterprise National Council</a>';
            formName = 'wbenc';
            formProperty = this.state.form.wbenc;
            expirationDateFormName = 'wbencExpirationDate';
        }

        return (
            <Row>
                <Col md={10}>
                    <FormGroup>
                        <CheckBox inline tip={this.setTip(uploadKey)} onChange={() => { this.evaluateBlank(uploadKey) }} name={formName} disabled={this.state.form.none || !this.state.enabled} label={label} />
                        <React.Fragment>
                            {this.state.form !== null && formProperty ? (
                                <React.Fragment key={formProperty}>
                                    <ReviewUpload
                                        key={uploadKey}
                                        reviewUpload={reviewUpload}
                                        config={UploadsConfig}
                                        onChange={this.handleReviewUpload}
                                        notApplicableAvailable={false}
                                        queueTypeCode={this.state.form.certificationQueueTypeCode} />
                                    <Row>
                                        <Col md={3}>
                                            <div className="input-group">
                                                <DatePicker className='dpThin'
                                                    required
                                                    name={expirationDateFormName}
                                                    placeholder='Expiration Date' />
                                                {this.setTip(this.handleExpDateTooltip(uploadKey)) && <span className="input-group-addon" style={{ border: 0 }}>
                                                    <Tooltip tip={this.setTip(this.handleExpDateTooltip(uploadKey))} />
                                                </span>}
                                            </div>
                                        </Col>
                                    </Row>
                                </React.Fragment>
                            ) : null}
                        </React.Fragment>
                    </FormGroup>
                </Col>
            </Row>
        );
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3 style={{ marginTop: "0px", position: "relative" }}>
                                    <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} certificationType={this.state.form.certificationType} certificationStatus={this.state.form.certificationStatus} />
                                </h3>
                                <hr />
                                <h3 style={{ marginTop: "0px" }}>
                                    Business Certification – 
                                    <small>
                                        Please select all that apply to your business
                                        &nbsp;&nbsp;
                                        <FastTrackLabel value={this.state.form.fastTrack} />
                                    </small>
                                    {this.renderAdminStepToolbar()}
                                    {this.state.form.allowPrinting && <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>}
                                </h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                {this.renderUploadFields()}
                                <Row>
                                    <Col md={10}>
                                        <FormGroup>
                                            <CheckBox inline name='cve' tip={this.setTip(TooltipCode.CERTIFICATION.CVE)} disabled={this.state.form.none || !this.state.enabled} label='CVE - <a href="https://www.va.gov/osdbu/verification/" target="_blank">Veterans Administration</a>' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={10}>
                                        <FormGroup>
                                            <CheckBox inline name='sbA8' tip={this.setTip(TooltipCode.CERTIFICATION.SBA8)} disabled={this.state.form.none || !this.state.enabled} label='SBA - <a href="https://www.sba.gov/federal-contracting/contracting-assistance-programs/8a-business-development-program" target="_blank">8(a) Socially and Economically Disadvantaged</a>' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={10}>
                                        <FormGroup>
                                            <CheckBox inline name='sba' tip={this.setTip(TooltipCode.CERTIFICATION.SBAHUBZONE)} disabled={this.state.form.none || !this.state.enabled} label='SBA - <a href="https://www.sba.gov/federal-contracting/contracting-assistance-programs/hubzone-program" target="_blank">HUBZone</a>' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={10}>
                                        <FormGroup>
                                            <CheckBox inline name='dvbe' tip={this.setTip(TooltipCode.CERTIFICATION.DISVETBUSENT)} disabled={this.state.form.none || !this.state.enabled} label='DVBE - <a href="https://www.dgs.ca.gov/" target="_blank">Disabled Veterans Business Enterprise</a>' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={10}>
                                        <FormGroup>
                                            <CheckBox inline name='naVOBA' tip={this.setTip(TooltipCode.CERTIFICATION.NAVOBA)} disabled={this.state.form.none || !this.state.enabled} label='NaVOBA - <a href="https://navoba.org/" target="_blank">National Veteran-Owned Business Association</a>' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={10}>
                                        <FormGroup>
                                            <CheckBox inline name='di' tip={this.setTip(TooltipCode.CERTIFICATION.DISABILITY)} disabled={this.state.form.none || !this.state.enabled} label='DI - <a href="https://disabilityin.org/" target="_blank">DisabilityIN</a>' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={10}>
                                        <FormGroup>
                                            <CheckBox inline onChange={this.evaluateNoneOfAbove || !this.state.enabled} name='none' tip={this.setTip(TooltipCode.CERTIFICATION.NONEOFABOVE)} label='None of the above' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={12}>
                                <Row>
                                    <Col md={10}>
                                        <label>&nbsp;</label>
                                        {this.state.form.otherFiles != null && this.state.form.otherFiles.length > 0 && (
                                            <FormGroup>
                                                {this.renderOtherFiles()}
                                            </FormGroup>
                                        )}
                                        {this.state.enabled && (this.state.form.otherFiles == null || this.state.form.otherFiles.length < 5) &&
											<Button type="button" bsStyle="link" onClick={this.handleAddAnotherCertification}>
                                                Add another Certification
											</Button>
										}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {this.state.form.showReview ?
                    <React.Fragment>
                        <Row>
                            <CommentsGrid
                                ref={(c) => { this._commentsGrid = c }}
                                comments={this.state.form.comments}
                                documents={this.state.form.reviewDocuments}
                                certificationKey={this.props.selectedId}
                                reviewTypeCode={"CER"}
                                queueTypeCode={this.state.form.certificationQueueTypeCode}
                                enableExport={true}
                                entityId={this.state.form.savedEntityId}
                                readonly={!this.state.privileges.edit || !this.state.enabled}
                                onSave={this.handleCommentsGrid}
                                onCommentChange={this.handleCommentChange} />
                        </Row>
                        {this.state.form.showComplete ?
                            <Row>
                                <ReviewPanel stepName="Business Certification"
                                    canComplete={(
                                        this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                                        this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                                        this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
                                    ) ||
                                        (this.state.form.reviewUploads.every((reviewUpload) => {
                                            return (reviewUpload.upload.uploadKey === "NGLCC" && (!this.state.form.nglcc || reviewUpload.validDocument)) ||
                                                (reviewUpload.upload.uploadKey === "NMSDC" && (!this.state.form.nmsdc || reviewUpload.validDocument)) ||
                                                (reviewUpload.upload.uploadKey === "WBENC" && (!this.state.form.wbenc || reviewUpload.validDocument));
                                        })
                                            && (this.state.form.otherFiles === null
                                                || this.state.form.otherFiles.every((document) => { return document.uploadModel && document.uploadModel.validDocument; })))}
                                    onChange={this.handleReviewStatus}
                                    reviewStatus={this.state.form.reviewStatus} />
                            </Row>
                            : null}
                    </React.Fragment>
                    : null}
            </React.Fragment>
        )
    }
}

export default BusinessCertification; 



// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/businessCertification/BusinessCertification.js